<template>
    <div id="SMFPlog">
        <div class="container">
            <h1>Blog Post #{{title}}</h1>
            <h5>{{outline}}</h5>

            <div v-html="entry"></div>

            <br />
            <h1>More Blog Posts</h1>

            <b-list-group class="plog-index">
                <b-list-group-item class="flex-column align-items-start" v-for='{index, slug, title, fileName, readingTime, released, language, outline} in content' :key="index" @click.stop="loadPage(fileName)">
                    <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">{{ title }} [{{ index }}]</h5>
                        <b-badge variant="primary" class="m-1" pill>reading time: {{ formatReadingTime(readingTime) }} min</b-badge>
                    </div>
                    <p class="mb-1">
                        <b-link @click.stop="loadPage(fileName,title,outline,index)">{{ outline }}</b-link>
                    </p>
                    <small>published at {{ formatReleased(released) }}</small>
                </b-list-group-item>
            </b-list-group>
            <br />
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Plog',
        data() {
            return {
                url: '/plog/index.json',
                status: 'loading...',
                contentLength: 0,
                content: [],
                entry: '',
                title: '',
                outline: ''
            }
        },
        mounted() {
            this.getIndex()
        },
        methods: {
            getIndex() {
                console.log('get index: ' + this.url)
                //  timeout == 0 ==> no timeout
                let self = this
                this.$http.get(this.url, {
                    timeout: 0,
                    progress: function (event) {
                        console.log(event.loaded + '/' + event.total)
                        self.status = 'progress ' + ((100 * event.loaded) / event.total) + '%'
                    }
                }).then(response => {
                    // this.data = response.body
                    this.contentLength = parseInt(response.headers.get('Content-Length'), 10)
                    console.log('web-request loaded ' + '(' + this.url + ') ' + this.contentLength + ' bytes')
                    // console.log(reponse.json())
                    response.json().then(function (data) {
                        console.log(data)
                        // data.forEach((element, index, array) => {
                        //   console.log(index + ' ' + element)
                        // })
                        self.content = data

                        //  load first page
                        if (self.content.length !== 0) {
                            console.log('load: ' + data[0].fileName)
                            var lastPage = self.content.length - 1
                            self.loadPage(data[lastPage].fileName, data[lastPage].title, data[lastPage].outline, (data[lastPage].index))
                        }
                    })
                }, response => {
                    console.log('web-request ' + ' FAILED')
                })
            },
            loadPage(fileName, title, outline, index) {
                this.title = (index + 1) + ': ' + title
                this.outline = outline
                fileName = fileName.substr(fileName, fileName.lastIndexOf('.')) + '.html'
                console.log('load page: ' + fileName)
                this.$http.get('/plog/' + fileName, {}).then(response => {

                    console.log('web-request loaded ' + '(' + response.url + ') ')
                    this.entry = response.body

                }, error => {
                    console.error('***error: ' + error.status + ' ' + error.statusText)
                    this.entry = error.status + ' ' + error.statusText + ' (' + error.url + ')'
                })
            },
            formatReadingTime(x) {
                return Number.parseFloat(x).toFixed(2)
            },
            formatReleased(dt) {
                var released = new Date(dt.substring(0, 19))
                var opt = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
                // console.log('locale: ' + this.$i18n.locale);
                var fmt = new Intl.DateTimeFormat(this.$i18n.locale, opt)
                return fmt.format(released)
            }
        }
    }
</script>

<style scoped lang="css">
    #SMFPlog {
        background: rgb(220,226,226);
    }

    h1, h2 {
        padding-bottom: .3em;
        border-bottom: 1px solid #eaecef;
    }

    code, kbd, pre, samp {
        font-family: monospace;
    }

    a.oction {
        opacity: 0;
        transition: opacity 0.2s;
        cursor: pointer;
    }

        a.oction:hover {
            opacity: 1;
        }

    p > a {
        text-decoration: none;
        color: blue;
    }

    blockquote > p {
        margin-bottom: 1px;
    }

    pre {
        background-color: #fafafa;
    }

        pre > code:hover {
            background-color: orange;
        }

    blockquote {
        border-left: 4px solid #eee;
        padding-left: 10px;
        color: #777;
        margin: 16px 20px;
    }

    figure {
        margin: 2%;
    }

    img {
        border: 2px solid #777;
    }

        img:hover {
            box-shadow: 0 0 10px #ccc;
        }

    div.gallery {
        display: grid;
        grid-gap: 12px;
        background-color: #eee;
    }

    div.smf-svg:hover {
        box-shadow: 0 0 10px #ccc;
    }

    div.gallery img {
        width: 100%;
        height: auto;
        object-fit: cover;
    }

    dl {
        display: flex;
        flex-flow: row wrap;
    }

    dt {
        font-weight: bold;
        flex-basis: 20%;
    }

        dt::after {
            content: ":";
        }

    dd {
        flex-basis: 70%;
        flex-grow: 1;
    }

    ul.alert {
        display: flex;
        list-style: none;
    }

        ul.alert > li {
            padding: 7px;
        }

            ul.alert > li:nth-child(2) {
                background-color: #ddd;
                border-radius: 5px;
            }

    sup {
        top: -.5em;
    }

    sub {
        bottom: -.25em;
    }

    sub, sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
    }

    aside {
        position: absolute;
        right: 2em;
        width: 20%;
        border: 1px #D5DBDB solid;
        color: #9C640C;
        padding: 0.5em;
        z-index: -1;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0px;
        border: 1px solid black;
    }

    table, th, td {
        padding: 5px;
        border: 10px solid black;
    }

    tr:nth-child(even) {
        background-color: #f2f2f2;
    }

    caption {
        font-weight: bold;
        color: white;
        background-color: DimGray;
        padding: 5px;
        text-align: left;
    }

    kbd {
        padding: 2px 4px;
        font-size: 90%;
        color: #ffffff;
        background-color: #333333;
        border-radius: 3px;
    }

    details > ul * {
        list-style-type: none;
        text-decoration: none;
        margin-left: 0em;
        padding-left: 0.7em;
    }
</style>
